// Basic Vue components
import { createApp } from 'vue'
import 'vue-style-loader';

// Setup Vue
window.Vue = createApp;
window.$ = window.jQuery = jQuery;

// Our extensions and components
import Axios from './classes/Axios.js';
import modalDynamic from './components/modal-dynamic.vue';
require ('./classes/PrototypeExt.js');

var app = createApp({

    components: {
      'modal-dynamic': modalDynamic,
    },

    data() {
        return {
            oasisApi:'',
            true: true,  // necessary to pass a boolean true and not a string
            false: false,  // necessary to pass a boolean true and not a string
            modals: [],  // Dynamic modals
            openModals: 0,  // Dynamic modals counting
            buttonYesAction: [],
            buttonNoAction: [],
            button3Action: [],

            showSelected: false,
            shows: shows,
            showIndex: undefined,
            showName: undefined,
            showData: {},
            showToken: '',
            accountMask: '',

            // Journal
            journalData: {
                batch: '',
                debits_decimal: 0.00,
                credits_decimal: 0.00,
                date: '',
                number: '',
                description: 'PR WE 09/03/2017',
            },

            journalLines: [],

            // Table
            payrollData: '',
            importData: [
                ['Paste Payroll Data with Headers']
            ],
        }
    },

    computed: {
        today() {
            let date = new Date();
            var day = date.getDate();
            var monthIndex = date.getMonth();
            var year = date.getFullYear();

            return year + '-' + this.pad(monthIndex*1 + 1) + '-' + this.pad(day);
        },
    },

    methods: {
        setShow( {target} ) {
            console.log (target);
            this.showIndex = target.value;
            this.showName = this.shows[target.value].name;
            this.accountMask = this.shows[target.value].mask;
            this.oasisApi = new Axios(this.shows[target.value].url);
            this.journalData.date = this.today;

            if (this.showData[this.showName] && this.showData[this.showName].apiUrl) {
                return true;
            } else {
                this.showData[this.showName] = {};
                this.showData[this.showName].apiUrl = this.shows[target.value].url;
                this.showData[this.showName].username = this.shows[target.value].username;
                this.showData[this.showName].password = this.shows[target.value].password;
                return true;
            }

        },

        getShowData() {
            if (! this.showData[this.showName] || ! this.showData[this.showName].apiUrl) {
                this.createDialog ({ "title": "Error", "body": "Please select a show.", "buttonNo": false, "buttonYesLabel": "OK"  });
            }

                // If here, the token was not available or invalid
                let data = {
                    username: this.showData[this.showName].username,
                    password: this.showData[this.showName].password
                };

                this.oasisApi.post('/auth', data)
                    .then(response => {
                        if (response.status === 200 && response.data === false) {
                            // No data to retrive
                            return false;
                        } else if (response.status === 200 && typeof response.data === 'object') {
                            console.log (response.data.token);
                            this.showToken = response.data.token;
                        } else {
                            alert ('Login Failed. Please try again.');
                        }
                        this.getCodes();
                    })
                    .catch(error => { console.log(error); }
                );
            this.showSelected = true;
        },

        getCodes() {
            if (! this.showToken) {
                this.createDialog ({ "title": "Error", "body": "Please Login First.", "buttonNo": false, "buttonYesLabel": "OK"  });
            }

            let tokenData = JSON.parse(localStorage.getItem('showData'));

            if (tokenData && tokenData[this.showName] && tokenData[this.showName].accounts && tokenData[this.showName].accounts.length > 0 &&
                tokenData[this.showName].series && tokenData[this.showName].series.length > 0 &&
                tokenData[this.showName].batches && tokenData[this.showName].batches.length > 0) {

                this.showData = tokenData;
                return true;
            }

            // load from api if localstorage is blank
            let options = {
                Authorization: 'Bearer ' + this.showToken
            };

            let accounts = new Promise((resolve, reject) => {
                this.getApiData('/accounts', options)
                .then(response => {
                    this.showData[this.showName].accounts = this.stripDashes(response);
                    resolve(true);
                })
                .catch(error => { console.log(error); return reject('Failed to get Accounts'); }
                );
            });

            let series = new Promise((resolve, reject) => {
                this.getApiData('/series', options)
                .then(response => {
                    this.showData[this.showName].series = response;
                    resolve(true);
                })
                .catch(error => { console.log(error); return reject('Failed to get Series'); }
                );
            });

            let freefields = new Promise((resolve, reject) => {
                this.getApiData('/freefields', options)
                .then(response => {
                    this.showData[this.showName].freefields = response;
                    resolve(true);
                })
                .catch(error => { console.log(error); return reject('Failed to get Free Fields'); }
                );
            });

            let batches = new Promise((resolve, reject) => {
                this.getApiData('/batches', options)
                .then(response => {
                    this.showData[this.showName].batches = response;
                    resolve(true);
                })
                .catch(error => { console.log(error); return reject('Failed to get Batches'); }
                );
            });

            // Once all is loaded, save to localstorage
            Promise.all([ accounts, series, freefields, batches ])
                .then(values => {
                    localStorage.setItem('showData', JSON.stringify(this.showData));
                    return true;
                });

        },

        getApiData(endpoint, options) {
            let result = [];

            let recursive = page => this.oasisApi.get(endpoint + page, options)
                .then(response => {
                    if (response.status === 200 && response.data.results) {
                        result = result.concat(response.data.results);
                        if (response.data.next) {
                            let nextPage = response.data.next.replace(this.showData[this.showName].apiUrl + endpoint,'');
                            return recursive(nextPage);
                        } else {
                            return result;
                        }
                    } else {
                        return false;
                    }
                })
                .catch(error => {
                    console.log (error);
                });

            return recursive('');
        },

        stripDashes(object){
            return object;
            for (let i=0; i < object.length; i++) {

            }
        },

        createPayrollTable() {
            var container = document.getElementById("payrollData");
            return new Handsontable(container, {
                data: this.importData
            });
        },

        resetPayrollTable() {
            this.importData = [ ['Paste Payroll Data with Headers'] ];
            this.payrollData.destroy();
            this.payrollData = this.createPayrollTable();
            this.journalLines  = [];
            this.journalData.debits_decimal = 0;
            this.journalData.credits_decimal = 0;
            this.journalData.number = '';
        },

        createJournal() {
            this.prepJournal()
                .then (response => {
                    // console.log (this.journalLines);
                    this.validateData();
                })
                .catch (error => {console.log (error) }
            );
        },

        prepJournal() {
            return new Promise ((resolve, reject) => {

                if (this.importData.length < 2) {
                    this.createDialog ({ "title": "Error", "body": "Please Paste in Payroll Data First.", "buttonNo": false, "buttonYesLabel": "OK"  });
                    return reject('No Payroll Data.');
                }

                let fieldHeaders = {};

                fieldHeaders.account = this.importData[0].indexOf('Account');
                fieldHeaders.series = this.importData[0].indexOf('Location');
                fieldHeaders.freefield = this.importData[0].indexOf('Free Field');
                fieldHeaders.description = this.importData[0].indexOf('Description');
                fieldHeaders.amount = this.importData[0].indexOf('Total');

                if (fieldHeaders.account < 0 || fieldHeaders.amount < 0 || fieldHeaders.description < 0) {
                    this.createDialog ({ "title": "Error", "body": "Please Check Field Headers.<br />Required fields are: \"Account,\", \"Total,\" and \"Description.\"", "buttonNo": false, "buttonYesLabel": "OK"  });
                    return reject('Missing a required field.');
                }

                this.journalData.debits_decimal = 0;
                this.journalData.credits_decimal = 0;
                this.journalLines=[];
                for (let i = 1; i < this.importData.length; i++) {
                    let row = this;

                    // fix account with mask
                    let maskedAccount = this.applyAccountMask(row.importData[i][fieldHeaders.account]);
                    let account = ( row.importData[i][fieldHeaders.account] ) ? row.showData[this.showName].accounts.find(function({code}){ return code.match(maskedAccount); }) : null;
                    let series = ( row.importData[i][fieldHeaders.series] ) ? row.showData[this.showName].series.find(function({code}){ return code.match(row.importData[i][fieldHeaders.series]); }) : null;
                    let freefield = ( row.importData[i][fieldHeaders.freefield] ) ? row.showData[this.showName].freefields.find(function({code}){ return code.match(row.importData[i][fieldHeaders.freefield]); }) : null;

                    let line = {};
                    line.account = (account) ? account.id : null;
                    line.series = (series) ? series.id : null;
                    line.freefield = (freefield) ? freefield.id : null;
                    line.description = row.importData[i][fieldHeaders.description];
                    line.amount_decimal = parseFloat(row.importData[i][fieldHeaders.amount]);
                    line.line_number = i;
                    if (line.amount_decimal >= 0 ) {
                        this.journalData.debits_decimal += line.amount_decimal; 
                    } else {
                        this.journalData.credits_decimal -= line.amount_decimal*-1; 
                    }

                    this.journalLines.push(line);
                }
                return (resolve(true));
            });

        },

        validateData() {
            let index = [];

            let errors = this.journalLines.filter(({account, series}, ind ) => {
                if (account == null || series == null) { index.push(ind); };
                return (account == null || series == null);
            });

            if (errors.length === 0) return true;

            for ( let i = 0; i < index.length; i++) {
                let tableIndex = parseInt(index[i]) + 1
                console.log (tableIndex);
                $($("#payrollData table tr")[tableIndex]).addClass("form-error");
            }
            for ( let i = 0; i < errors.length; i++) {
                console.log (errors[i]);
            }
        },

        addJournal() {
            let data = this.journalData;
            let dataLines = this.journalLines;
            let newId = '';
            let existingId = undefined;

            return new Promise((resolve, reject) => {
                // In case the journal was created but without the lines
                if (existingId) {
                    this.addJournalLines(existingId, this.journalLines)
                        .then((linesResponse) => {
                            this.addJournalLines(existingId, this.journalLines)
                                .then((linesResponse) => {
                                    console.log('Finished adding lines');
                                })
                                .catch(error => {
                                    return reject('Journal lines could not be added');
                                })
                        })
                        .catch(error => {
                            return reject('Journal lines could not be added');
                        })
                    ;
                // Normal operation
                } else {
                    this.oasisApi.post('/jes', data)
                        .then(response => {
                            console.log ('Creating Journal');
                            console.log (response);
                            if (response.status == 201) {
                                newId = response.data.id;
                                this.journalData.id = newId;
                            } else {
                                return reject('Journal Creation Failed.');
                            }

                            this.addJournalLines(newId, this.journalLines)
                                .then((linesResponse) => {
                                    this.addJournalLines(newId, this.journalLines)
                                        .then((linesResponse) => {
                                            console.log('Finished adding lines');
                                        })
                                        .catch(error => {
                                            return reject('Journal lines could not be added');
                                        })
                                })
                                .catch(error => {
                                    return reject('Journal lines could not be added');
                                })
                            ;

                            return resolve("Added Journal ID " + newId);
                        })
                        .catch(error => {
                            return reject('Journal could not be added');
                        }
                    );
                }
            });

        },

        addJournalLines(id, lines) {
            return new Promise((resolve, reject) => {
                for(let i=0; i < lines.length; i++) {
                    this.oasisApi.post('/jes/' + id + '/lines', lines[i])
                        .then(response => {
                            if (response.status != 201) return reject('Journal line '+ i + ' failed.');
                        })
                        .catch(error => {
                            return reject('Journal line '+ i + ' failed.' + JSON.stringify(error));
                        });
                }
            });

        },

        applyAccountMask(account) {
            if (! account) { return account; }
            let maskedAccount = '';

            if (this.accountMask) {
                let j = 0;
                for (let i = 0; i < this.accountMask.length; i++) {
                    if (! account[j] ) {
                        return account;
                    } else if (this.accountMask[i] === 'x') {
                        maskedAccount += account[j];
                        j++;
                    } else if (this.accountMask[i] === '-' && account[j] === '-') {
                        maskedAccount += '-';
                        j++;
                    } else if (this.accountMask[i] === '-') {
                        maskedAccount += '-';
                    } else if (this.accountMask[i] === ':') {
                        maskedAccount += ':';
                    } else if (this.accountMask[i] === ' ') {
                        maskedAccount += ' ';
                    } else {
                        j++;
                    }
                }

                return maskedAccount;
            } else {
                return account;
            }

        },

        // pad 1-digit months/days
        pad(n) {
            return n < 10 ? '0' + n : n;
        },

        // Create a dynamic modal dialog box with buttons and labels
        createDialog(options) {
            let index = this.openModals;
            options.id = index;

            if (options.buttonYesAction) { this.buttonYesAction[index] = options.buttonYesAction;
            } else { this.buttonYesAction[index] = function () {}; }

            if (options.buttonYesLabel) { this.buttonYesLabel = options.buttonYesLabel;
            } else { options.buttonYesLabel = 'Yes'; }

            if (options.buttonNoAction) { this.buttonNoAction[index] = options.buttonNoAction;
            } else { this.buttonNoAction[index] = function () {}; }

            if (options.buttonNoLabel) { this.buttonNoLabel = options.buttonNoLabel;
            } else { options.buttonNoLabel = 'No'; }

            if (options.button3Action) { this.button3Action[index] = options.button3Action;
            } else { this.button3Action[index] = function () {}; }

            if (options.button3Label) { this.button3Label = options.button3Label;
            } else { options.button3Label = 'Maybe'; }

            this.modals.push(options);
            this.openModals++;
        },

        // Close the dynamic modal
        closeModal(index) {
            this.modals.splice(index, 1);
            this.buttonYesAction.splice(index, 1);
            this.buttonNoAction.splice(index, 1);
            this.button3Action.splice(index, 1);
            this.openModals--;
        },

        modalConfirm(index) {
            this.buttonYesAction[index]();
        },

        modalCancel(index) {
            this.buttonNoAction[index]();
        },

        modalButton3(index) {
            this.button3Action[index]();
        },
    },

    watch: {
    },

    created() {
    },

    beforeCreate() {
    },

    mounted() {
        // Load data provided by server, if any
        $("#login").focus();
        this.payrollData = this.createPayrollTable();
        if (localStorage.getItem('showData')){
            this.showData = JSON.parse(localStorage.getItem('showData'));
        }
        localStorage.clear();
    }

}).mount("#payroll-loader");